import React from 'react'
import { authRoles } from '../../auth/authRoles'

const AddNewOrgRoutes = [
    {
        path: '/Organization/newOrg',
        component: React.lazy(() => import('./AddNewOrg')),
        auth: authRoles.addNewOrganization,
    },
    {
        path: '/Organization/OrgManagement',
        component: React.lazy(() => import('./OrgManagement')),
        auth: authRoles.orgManagement,
    },
    {
        path: '/Organization/ReviewOrg/:id',
        component: React.lazy(() => import('./ReviewOrg')),
        auth: authRoles.orgManagement,
    },
    
]

export default AddNewOrgRoutes